import 'reflect-metadata';
import { defineNuxtRouteMiddleware, navigateTo } from '#imports';
import { useRootService } from '@kaokei/use-vue-service';
import { resolveGalaxyAccess } from '@core/pages/oj/galaxy/components/home/galaxy-home.helpers';
import { UserService } from '@core/services/user.service';

/**
 * 银河争霸赛比赛页面访问守卫
 *
 * 规则：未登录 或 非履约 且 非老师 → 重定向 OJ 首页('/')，均不弹登录弹窗。
 * 履约字段来源：userService.user.exerciseId 不为空；
 * 老师字段来源：userService.user.accountId 有值（老师/家长等查看学生数据的账号）。
 */
export default defineNuxtRouteMiddleware(async () => {
  if (import.meta.client) {
    const userService = useRootService(UserService);
    const isLogin = userService.isLogin();
    const isFulfillmentUser = userService.user.exerciseId != null;
    // accountId 有值即老师身份（学生账号该字段为空/0）
    const isTeacher = (userService.user.accountId ?? 0) > 0;
    const redirect = resolveGalaxyAccess({
      isLogin,
      isFulfillmentUser,
      isTeacher,
    });
    if (redirect) return navigateTo(redirect);
  }
});
